'use client';

import { Form, GuidesButton, ProgressBar } from '@insta-club/ui';
import { Container } from 'src/libs/components/layout';

interface IProps extends React.PropsWithChildren {
    icon: React.ReactNode;
    title: string;
    description: string;
    currentStep: number;
    totalSteps: number;
    form: ReturnType<typeof import('@insta-club/hooks').useCustomForm>;
    guideKey?: string;
}

function AddPageFormLayout({ children, title, description, currentStep, totalSteps, icon, form, guideKey }: IProps) {
    const progress = (currentStep / totalSteps) * 100;

    return (
        <>
            <Container hasHeader>
                <div className='relative z-10 pt-8 pb-12'>
                    <div className='mb-24'>
                        <div className='mb-3 flex items-center justify-between text-white'>
                            <span className='text-base font-normal'>
                                سوال {currentStep} از {totalSteps}
                            </span>
                        </div>
                        <ProgressBar
                            percentage={progress}
                            barClassName='bg-secondary-500'
                            className='bg-primary-400'
                            direction='rtl'
                        />
                    </div>
                    <div className='relative'>
                        <div className='relative z-20 rounded-3xl bg-white p-3'>
                            <div className='absolute -top-[60px] right-[18px]'>{icon}</div>
                            <div className='flex items-center justify-end pt-4 pl-4'>
                                {guideKey ? <GuidesButton guideKey={guideKey} /> : null}
                            </div>
                            <div className='p-3'>
                                <div className='mb-5 space-y-3'>
                                    <h4 className='text-base font-bold text-gray-600'>{title}</h4>
                                    <p className='text-[15px] font-normal text-gray-500'>{description}</p>
                                </div>
                                <Form form={form} onSubmit={() => {}}>
                                    {children}
                                </Form>
                            </div>
                        </div>
                        <div className='absolute bottom-0 left-0 z-10 flex w-full justify-center'>
                            <div className='bg-primary-300 absolute -top-[3px] z-0 mx-auto flex h-[23px] w-[90%] justify-center rounded-b-4xl'></div>
                            <div className='bg-primary-400 absolute top-[18px] -z-[1] mx-auto h-[17px] w-[82%] rounded-b-4xl'></div>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
}

export default AddPageFormLayout;

